module.exports = __webpack_public_path__ + "static/assets/4948e6764d2214fe0c09621c6defe06b.svg";